/**
 * Faceted search - Inputs
 */
(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let inputs = document.querySelectorAll('.js-facet-input');

    if (!form || !inputs.length) {
        return;
    }

    // Prevent preselection after inputs are changed
    inputs.forEach((input) => {
        input.addEventListener('click', H_Tools.preselect.disable);
    });

    // Change the behaviour of the 'Enter' key for some inputs
    form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        let focused = document.activeElement;

        if (!focused) {
            return;
        }

        if (focused.type === 'checkbox') {
            event.preventDefault(); // Prevent form submission

            // Make checkboxes togglable with the Enter key
            focused.checked = !focused.checked;
            focused.dispatchEvent(new Event('change'));
            form.dispatchEvent(new Event('input'));
        }

        // Bonus
        if (focused.type === 'radio') {
            event.preventDefault(); // Prevent form submission
        }
    });
})();
